import { Version } from '@enp/platform-api-client';

import { VersionStoreModel } from '@domain/metadata';

export const mapVersionApiModelToStoreModel = (version: Version): VersionStoreModel => {
  return {
    version: version.version,
    apiVersion: version.apiVersion,
  };
};
